import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen relative overflow-hidden" }
const _hoisted_2 = { class: "relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8" }
const _hoisted_3 = { class: "w-full max-w-7xl" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-2 mx-auto" }
const _hoisted_5 = { class: "brand-logo-container" }
const _hoisted_6 = ["src", "alt", "onClick"]

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { BRANDS } from '@/config/brands'
import type { Brand } from '@/config/brands'


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandSelectionView',
  setup(__props) {

const router = useRouter()
const brands = ref(BRANDS)
const isAnimating = ref(false)

// eslint-disable-next-line @typescript-eslint/no-var-requires
const backgroundImage = require('@/assets/staticbg.png')

onMounted(() => {
  // Trigger animation on mount
  setTimeout(() => {
    isAnimating.value = true
  }, 100)
})

const selectBrand = (brand: Brand) => {
  router.push({
    name: 'signup',
    params: { brandSlug: brand.slug }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute inset-0 bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: `url(${_unref(backgroundImage)})` })
    }, null, 4),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute inset-0 bg-white bg-opacity-90" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brands.value, (brand) => {
            return (_openBlock(), _createElementBlock("div", {
              key: brand.id,
              class: _normalizeClass(["brand-card", { 'animate-brand': isAnimating.value }])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: brand.logo,
                  alt: brand.name,
                  class: "brand-logo",
                  onClick: ($event: any) => (selectBrand(brand))
                }, null, 8, _hoisted_6)
              ])
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})